import {
  Button,
  Classes,
  Dialog,
  FileInput,
  FormGroup,
  HTMLSelect,
  Switch,
} from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { SpedTabelaStore } from "../../stores/sped/SpedTabelaStore";
import moment from "moment";

interface SpedTabelasPageProps {
}

interface SpedTabelasPageState {
}

@observer
export class SpedTabelasPage
  extends React.Component<SpedTabelasPageProps, SpedTabelasPageState> {

  obs = observable({
    pacote: "" as string,
    tabela: "" as string,

    loading_import: false as boolean,
    open_import_produtos: false as boolean,
    file_name: "Selecione um arquivo TXT" as string,
    vigencia: true as boolean
  })

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("Sped Tabelas");
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar"
      />
    );
  };

  handleOptionsTabela() {

    if (this.obs.pacote == "pa") {
      return (<>
        <option value="">Selecione uma tabela</option>
        <option value="1">5.1.1 - Tabela de Códigos de Ajustes da Apuração do ICMS</option>
        <option value="2">5.3 - Tabela de Ajustes e Informações de Valores Provenientes de Documento Fiscal</option>
        <option value="3">5.7 - Tabela Código de Motivos de Restituição e Complementação ICMS ST</option>
        <option value="3">5.9.1 - Tabela de Itens UF Índice de Participação dos Municípios</option>
        <option value="4">Tabela de Códigos de Receita</option>
      </>)
    }

    if (this.obs.pacote == "rs") {
      return (<>
        <option value="">Selecione uma tabela</option>
        <option value="1">5.1.1 - Tabela de Códigos de Ajustes da Apuração do ICMS</option>
        <option value="2">5.2 - Tabela de Iinformações Adicionais da Apuração - Valores Declaratórios</option>
        <option value="3">5.3 - Tabela de Ajustes e Informações de Valores Provenientes de Documento Fiscal</option>
        <option value="4">5.5 - Tabela de Tipos de Utilização dos Créditos Fiscais - ICMS</option>
        <option value="5">5.7 - Tabela Código de Motivos de Restituição e Complementação ICMS ST</option>
        <option value="6">Tabela de Códigos de Receita</option>
        <option value="7">Tabela de Itens UF índice de Participação dos Municípios - RS</option>
      </>)
    }

    if (this.obs.pacote == "to") {
      return (<>
        <option value="">Selecione uma tabela</option>
        <option value="1">5.1.1 - Tabela de Códigos de Ajustes da Apuração do ICMS</option>
        <option value="2">5.2 - Tabela de Iinformações Adicionais da Apuração - Valores Declaratórios</option>
        <option value="3">Tabela de Códigos de Receita</option>
        <option value="4">Tabela de Itens UF índice de Participação dos Municípios - RS</option>
      </>)
    }

    return (<>
      <option value="">Selecione uma tabela</option>
      <option value="1">3.1.1 - Tabela Versão do Leiaute - Sped Fiscal</option>
      <option value="2">4.4.6 - Tabela de Códigos dos Totalizadores Parciais da REDUÇÃO Z</option>
      <option value="3">5.4 - Tabela de Códigos das Obrigações do ICMS a Recolher</option>
      <option value="4">CEST - Código Especificador da Substituição Tributária</option>
      <option value="5">Tabela Código Fiscal de Operação e Prestação - CFOP</option>
      <option value="6">Tabela de Muncípios do IBGE</option>
      <option value="7">Tabela de Países do IBGE</option>
      <option value="8">Tabela de Países SISCOMEX</option>
      <option value="9">Tabela de Produtos para Combustíveis / Solvente</option>
      <option value="10">Tabela Gênero do Item de Mercadoria/Serviço</option>
      <option value="11">Tipo de Conhecimento de Transporte Eletrônico</option>
      <option value="12">Tipo do Conhecimento de Transporte</option>
      <option value="13">UF Código IBGE - Sigla</option>
      <option value="14">UF Sigla</option>
    </>)

  }

  async handleChangeTabela(e) {

    this.obs.tabela = e

    await SpedTabelaStore.handleLoadTabelas(this.obs.tabela, this.obs.pacote, this.obs.vigencia)

  }

  async handleChangePacote(e) {

    this.obs.pacote = e

    this.obs.tabela = ""

    SpedTabelaStore.obs.dadosTabela = [];

  }

  handleFileInputChange = async (event) => {

    this.obs.loading_import = true;

    const file = event.target.files[0];

    this.obs.file_name = file.name

    var data = new FormData();
    data.append("file", file);
    data.append("tabela", this.obs.tabela);
    data.append("pacote", this.obs.pacote);
    data.append("uf", this.obs.pacote);

    let res = await SpedTabelaStore.handleImport(data)

    if (res) {

      await SpedTabelaStore.handleLoadTabelas(this.obs.tabela, this.obs.pacote, this.obs.vigencia)

      this.obs.open_import_produtos = false;

      this.obs.file_name = "Selecione um arquivo TXT"

    }

    this.obs.loading_import = false;

  };

  handleImport() {

    this.obs.open_import_produtos = true;

  };

  async handleAplicaCredito(id, checked) {

    let resp = await SpedTabelaStore.handleAplicaCredito(id, checked)

    if (resp) {

      SpedTabelaStore.obs.dadosTabela.map(value => {

        if ((value._id || value.id) == id) {

          value.credito = checked

        }

      })

    }

  }

  buttonFormatterCredito = (cell, row) => {
    return (
      <div>
        <Switch
          className="select-regras"
          innerLabelChecked="Crédito"
          innerLabel="Débito"
          checked={row.credito}
          onChange={(e: any) => this.handleAplicaCredito(row.id, e.target.checked)}
        />
      </div>
    );
  }

  dateFormatter(cell, row) {

    if (cell) {

      return moment(cell).add(3, "hour").format("DD/MM/YYYY");

    }

    return ""

  };

  async handleChangeVigencia() {

    this.obs.vigencia = !this.obs.vigencia

    await SpedTabelaStore.handleLoadTabelas(this.obs.tabela, this.obs.pacote, this.obs.vigencia)

  }


  render() {

    const options = {
      searchField: this.createCustomSearchField,
    };

    let itens = SpedTabelaStore.obs.dadosTabela?.map(sped => {
      return ({
        id: (sped.id || sped._id),
        codigo: sped.codigo,
        descricao: sped.descricao,
        data_inicio: sped.data_inicio,
        data_fim: sped.data_fim,
        credito: (sped.credito || false),
      });
    });

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    return (
      <>
        <MDBRow>
          <MDBCol xl="5" lg="5" md="5" sm="5" xs="5">
            <FormGroup label="Pacote">
              <select
                className="bp3-button bp3-align-left"
                onChange={(e) => this.handleChangePacote(e.target.value)}
                value={this.obs.pacote}
              >
                <option value="">Selecione um pacote</option>
                <option value="pa">Tabelas do Pará</option>
                <option value="rs">Tabelas do Rio Grande do Sul</option>
                <option value="to">Tabelas do Tocantins</option>
                <option value="all">Tabelas Globais</option>
              </select>
            </FormGroup>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol xl="5" lg="5" md="5" sm="5" xs="5">
            <FormGroup label="Tabela">
              <select
                className="bp3-button bp3-align-left"
                onChange={(e) => this.handleChangeTabela(e.target.value)}
                value={this.obs.tabela}
              >
                {this.obs.pacote == ""
                  ? <option value="">Nenhuma tabela encontrada</option>
                  : this.handleOptionsTabela()}
              </select>
            </FormGroup>
          </MDBCol >
        </MDBRow >

        {this.obs.tabela != "" && this.obs.pacote != "" &&
          <>
            <Button
              icon="import"
              className="btnRoxo"
              onClick={() => this.handleImport()}
              loading={this.obs.loading_import}
            >
              Importar
            </Button>

              <div style={{ display: "flex", width: "100%" }}>
                <Switch
                  label={"Filtro Vigência"}
                  checked={this.obs.vigencia}
                  onChange={() => this.handleChangeVigencia()}
                  innerLabelChecked="Vigentes" innerLabel="Não vigentes"
                  style={{ marginTop: 20, fontSize: 12, fontWeight: 600 }}
                  alignIndicator="right"
                />
              </div>

            <BootstrapTable className="TableDefault" data={itens} ref="table" options={options} search>
              <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="codigo" width="10%">Código</TableHeaderColumn>
              <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.dateFormatter} dataField="data_inicio" width="15%">Data de Início</TableHeaderColumn>
              <TableHeaderColumn dataFormat={this.dateFormatter} dataField="data_fim" width="15%"> Data de Fim</TableHeaderColumn>
              {user_admin && <TableHeaderColumn dataFormat={this.buttonFormatterCredito} width="15%">Crédito</TableHeaderColumn>}
            </BootstrapTable>

            <div style={{ marginTop: 5, float: "right", marginBottom: 120 }} />
          </>
        }

        <Dialog
          isOpen={this.obs.open_import_produtos}
          onClose={() => this.obs.open_import_produtos = false}
          title={"Importar"}
        >
          <div className={Classes.DIALOG_BODY}>

            <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>

              <b>Observação:</b> Ao importar o arquivo, todos os itens cadastrados no sistema serão substituídos pelos itens presentes no arquivo, conforme o filtro selecionado. <br />

            </p>

            <br />

            <FormGroup label="">
              <FileInput text={this.obs.file_name} className="bp3-fill bp3-file-input-has-selection input-file-certificado" onInputChange={this.handleFileInputChange} />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_import_produtos = false} />
            </div>
          </div>

        </Dialog>
      </>
    );
  }
}
